import mapbox from 'mapbox-gl';

mapbox.accessToken = __myapp.env.MAPBOX_ACCESS_TOKEN;
const key = {};

export { mapbox, key };